import { useAjax, useMzMutation } from "@bsm/component";

export const useActivateScholarityMutation = () => {
    const ajax = useAjax();

    return useMzMutation(
        (payload: Record<string, any>) => {
            return ajax.send({
                type: "POST",
                content_type: "application/json",
                url: "student/scholarity/activate",
                data: payload,
            });
        },
        {
            error_message: false
        }
    );
}